module.exports = "#ngxspinner {\r\n    z-index: 1000;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/callback/callbacks.component.css
// module id = ./src/app/callback/callbacks.component.css
// module chunks = main